module.exports = __webpack_public_path__ + "img/Galicia.4a06dafa.svg";